import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/mcp-gateways"
)({
  // Read-gate the whole feature at the layout (this covers the list). The
  // /new and /edit child routes add their own create / update guards on top,
  // so direct navigation to them requires the matching write permission.
  async beforeLoad(ctx) {
    await requireProjectPermission(ctx, PROJECT.mcpGateways.read);
  },
  component: RouteComponent,
  loader: () => ({
    crumb: "MCP Gateways",
  }),
});

function RouteComponent() {
  // Contain the gateway child routes' loading (edit-page detail query, tool
  // catalog) to this subtree so navigating between list / new / edit never
  // suspends the shared app layout and tears down the sidebar.
  return (
    <Suspense
      fallback={
        <div className="flex h-full items-center justify-center">
          <Loader2 className="size-6 animate-spin text-muted-foreground" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  );
}
